<template>

      <div id="modal-example" uk-modal>
        <div class="uk-modal-dialog uk-modal-body">
          <h2 class="uk-modal-title">{{ data.title }}</h2>
            <div v-if="component">
                <component :is="component"></component>
            </div>
            <div v-if="data.form">
                                <form-container
                                :reset-signal="resetSignal"
                                :form_title="data.formTitle"
                                :fieldList="data.formFields"
                                @output="submitForm">

                                </form-container>
            </div>
            <p>{{ data.body }}</p>
            <div v-html="data.html"></div>
            <p class="uk-text-right">
            <button v-if="data.cancel" class="uk-button uk-button-default uk-modal-close" type="button">{{ data.cancel || 'Exit' }}</button>
            <button v-if="data.accept" class="uk-button uk-button-primary uk-modal-close" type="button" @click="acceptEvent">{{ data.accept || 'Ok'}}</button>
          </p>
        </div>
      </div>

</template>

<script>
    import formContainer from "./formContainer.vue"

    export default {
        name: "Modal",
        props: ["data", "component", "form", "resetForm"],
        components: {formContainer},
        data: function() {
            return {
                resetSignal: false,
            }
        },
        methods: {
            acceptEvent: function() {
                this.$emit('accept')
            },
            submitForm: function(output){
                this.$emit('formOutput', output)
            }
        },
        watch: {
            resetForm: function (val) {
                if (val){
                    console.log("RECEIVED RESET SIGNAL")
                  this.resetSignal = true;
                } else {
                    this.resetSignal = false;
                }

            }
        }
    }
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";

  button:not(:last-of-type) {
    margin-right: 8px;
  }

</style>
